import ListProcesses from "@/views/customer/query/containers_intermediated/ListProcesses.vue";
import ListContainers from "@/views/customer/query/containers_intermediated/ListContainers.vue";
import ShowContainer from "@/views/customer/query/containers_intermediated/ShowContainer.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "cus",
  role: "query",
  permission: "containers_intermediated",
});

export default [
  {
    path: "/cus/:customer_id/query/containers_intermediated",
    name: routeName(""),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/cus/:customer_id/query/containers_intermediated/:agro_exporter_process_id/containers",
    name: routeName("list_containers"),
    component: ListContainers,
    props: true,
    meta: META
  },
  {
    path: "/cus/:customer_id/query/containers_intermediated/:agro_exporter_process_id/container/:container_id",
    name: routeName("show_container"),
    component: ShowContainer,
    props: true,
    meta: META
  }
];
